export class Artist {
  id: number;
  name: string;
  code: string;

  constructor(rawData: { id: number; name: string; code: string }) {
    this.id = rawData.id;
    this.name = rawData.name;
    this.code = rawData.code;
  }
}
